import styled from 'styled-components';

import { Button } from '../../../Toolkit/Button';

const CloseButton = styled(Button)`
  padding: 0;
  cursor: pointer;
  width: 32px;
  height: 32px;
  color: ${({ theme }) => theme.colors.GREY_DARK};
  // Position close button and its contents at the top of the container
  align-self: start;
  display: flex;
  align-items: center;
  justify-content: center;
  
  // The SharedButton styles offset all nested SVGs by 3px for some reason, so we need to override that here to allow proper centering
  svg {
    margin-top: 0;
  };
  }
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export { Header, CloseButton };
